module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-slash-fill-6e9c2366.svg";